import { computed, onMounted, ref } from '@vue/composition-api';
import Vue from 'vue';

const CreateModalHandler = function() {
  let ct = ref(0);
  let openedModals = ref([]);

  let isModalOpen = computed(() => {
    return openedModals.value.find(f => f.isOpened == true) != null;
  });
  let modals = computed(() => {
    return openedModals.value;
  });
  let getModalByName = function(name) {
    return computed(() => {
      return openedModals.value.find(f => f.name == name);
    });
  };

  let OpenModal = function(name, data, options = {}) {
    let defaultModalData = {
      name: name,
      data: data,
      options: options,
      isOpened: true,
      isLoading: false,
      id: ct.value++,
    };
    let modals = openedModals.value;
    modals.push(defaultModalData);
    openedModals.value = modals;
  };
  let SetModalLoading = function(id, state) {
    let modal = openedModals.value.find(f => f.id == id);
    if (modal) {
      modal.isLoading = state;
    }
  };
  let CloseModal = function(id) {
    let modal = openedModals.value.find(f => f.id == id);
    if (modal) {
      modal.isOpened = false;
    }
    setTimeout(() => {
      let modals = openedModals.value;
      modals = modals.filter(f => f.id != id);
      openedModals.value = modals;
    }, 1000);
  };

  return {
    isModalOpen,
    modals,
    getModalByName,
    OpenModal,
    SetModalLoading,
    CloseModal,
  };
};
export const modalHandler = CreateModalHandler();

export const MODAL_EVENT_TYPE = Object.freeze({
  FormSuccess: 'form-success',
});

export const modalEvents = new Vue();

export const useModal = function(props, context) {
  let CloseModal = function() {
    modalHandler.CloseModal(props.modal.id);
  };
  let SetModalLoading = function(state) {
    modalHandler.SetModalLoading(props.modal.id, state);
  };
  let EmitEvent = function(type, data) {
    modalEvents.$emit(props.modal.name, { type, data });
  };

  return { CloseModal, SetModalLoading, EmitEvent };
};
